import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { getQueryString, writeCookie, readCookie } from '@/tools/tools';
import { wxCallback } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.wxLoginCallBack();
    }
  }, {
    key: "wxLoginCallBack",
    value: function () {
      var _wxLoginCallBack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, anchor, obj, path, _anchor, _obj;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return wxCallback({
                code: getQueryString('code'),
                state: getQueryString('state'),
                companyId: 1
              });
            case 2:
              res = _context.sent;
              if (!(res.data.code === 100)) {
                _context.next = 13;
                break;
              }
              writeCookie('accessToken', res.data.data);
              _context.next = 7;
              return this.setUserInfoList();
            case 7:
              anchor = readCookie('anchor');
              if (anchor) {
                obj = {
                  accessToken: res.data.data,
                  userName: this.userinfor.userinfolist.nickName,
                  userId: this.userinfor.userinfolist.id,
                  userPhoto: this.userinfor.userinfolist.headImgUrl,
                  macCode: '',
                  phone: this.userinfor.userinfolist.phone
                };
                if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  this.webTransport.getUserLoginData(JSON.stringify(obj));
                } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
                } else {
                  window.JsIntrS.getUserLoginData(obj);
                }
              }
              path = this.$route.query.redirect;
              if (path) {
                this.$router.push(path);
              } else {
                this.$router.push('/');
              }
              _context.next = 14;
              break;
            case 13:
              if (res.data.code === 1021) {
                _anchor = readCookie('anchor');
                _obj = {
                  wxOpenId: res.data.data.openid,
                  unionId: res.data.data.unionid,
                  headImage: res.data.data.headimgurl,
                  qqUnionId: '',
                  nickName: res.data.data.nickname,
                  equip: _anchor ? _anchor.equip : 4,
                  model: _anchor ? _anchor.model : '',
                  equipVersion: _anchor ? _anchor.version : '',
                  version: _anchor ? _anchor.version : '',
                  equipMeid: _anchor ? _anchor.version : ''
                };
                this.$router.push({
                  path: '/bindphone',
                  query: _obj
                });
              } else {
                this.$message.error(res.data.message);
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function wxLoginCallBack() {
        return _wxLoginCallBack.apply(this, arguments);
      }
      return wxLoginCallBack;
    }() // 比较版本
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      v1 = v1.split('.');
      v2 = v2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
        v1.push('0');
      }
      while (v2.length < len) {
        v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i]);
        var num2 = parseInt(v2[i]);
        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }
      return 0;
    }
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([State('user')], default_1.prototype, "userinfor", void 0);
default_1 = __decorate([Component({})], default_1);
export default default_1;